import { useEffect, useState } from 'react';
import type { Locale } from '../types/locale';
import { timezoneCountries } from '../data/countries';
import { lookupVisitorLocation, visitorTimeZone } from '../utils/visitorLocation';
import { localeForCountry } from '../utils/locale';

type Suggestion = { locale: Locale; country: string } | null;

function suggestionFor(country: string | null | undefined): Suggestion {
  const locale = localeForCountry(country);
  return locale && country ? { locale, country: country.toUpperCase() } : null;
}

// The country the visitor is browsing from, and its language — null when we don't offer that language
export function useSuggestedLocale(): Suggestion {
  const [suggestion, setSuggestion] = useState<Suggestion>(() => suggestionFor(timezoneCountries[visitorTimeZone()]));

  useEffect(() => {
    let active = true;
    lookupVisitorLocation().then(({ countryCode }) => {
      if (active && countryCode) setSuggestion(suggestionFor(countryCode));
    });
    return () => {
      active = false;
    };
  }, []);

  return suggestion;
}
